import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import RateInputChoice from './RateInputChoice';
import styles from './styles.module.scss';

interface OwnProps {
	updateShippingMarkup: boolean;
	shippingMarkup: Nullable<number>;
	updateSalesMarkup: boolean;
	salesMarkup: Nullable<number>;
	updateTax: boolean;
	tax: Nullable<number>;
	timezone: Nullable<string>;
	levelWord: 'Company' | 'Job';
	change: (field: string, value: unknown) => void;
}

type Props = OwnProps;

export const MaterialRateBulkUpdateForm: React.FC<Props> = (props) => {
	const {
		timezone,
		updateShippingMarkup,
		shippingMarkup,
		updateSalesMarkup,
		salesMarkup,
		updateTax,
		tax,
		levelWord,
		change,
	} = props;

	const tomorrow = React.useMemo(() => {
		if (!timezone) {
			return null;
		}
		const now = new Date();
		const nowInCompanyTimezoneISO = TimeUtils.adjustDateToTimezone(now.toISOString(), timezone, TimeFormat.ISO_DATETIME);
		const tomorrowInCompanyTimezone = TimeUtils.addDays(nowInCompanyTimezoneISO, 1, TimeFormat.ISO_DATETIME);
		return TimeUtils.formatDate(tomorrowInCompanyTimezone, TimeFormat.DATE_ONLY);
	}, [timezone]);

	return (
		<form>
			<Row className={`row--padded-top ${styles.row}`}>
				<Col md={8}>
					<RateInputChoice
						change={change}
						levelWord={levelWord}
						rate={shippingMarkup}
						rateKey="shippingMarkup"
						title="Shipping Markup (%)"
						updateKey="updateShippingMarkup"
						updateRate={updateShippingMarkup}
					/>
				</Col>
				<Col md={8}>
					<RateInputChoice
						change={change}
						levelWord={levelWord}
						rate={salesMarkup}
						rateKey="salesMarkup"
						title="Sales Markup (%)"
						updateKey="updateSalesMarkup"
						updateRate={updateSalesMarkup}
					/>
				</Col>
				<Col md={8}>
					<RateInputChoice
						change={change}
						levelWord={levelWord}
						rate={tax}
						rateKey="tax"
						title="Tax (%)"
						updateKey="updateTax"
						updateRate={updateTax}
					/>
				</Col>
			</Row>
			<Row>
				<div className={styles.instructions}>
					New rate(s) will be applied and valid from <b>tomorrow, {tomorrow}</b>.
					Manually added rates will override {levelWord.toLowerCase()} level rates. Continue?
				</div>
			</Row>
		</form>
	);
};
